/*
  单个商品的数据内容
*/

export default {
  state: {
    id: null,
    title: undefined,
    covers: [],
    summary: undefined,
    detail: undefined,
    creditsNeeded: null,
    cashNeeded: null
  },
  mutations: {
    UPDATE_COMMODITIE (state, commoditie) {
      ['id', 'title', 'covers', 'summary', 'detail', 'creditsNeeded', 'cashNeeded'].forEach(key => {
        state[key] = commoditie[key]
      })
    }
  },
  actions: {
    updateCommoditie ({ commit }, commoditie) {
      commit('UPDATE_COMMODITIE', commoditie)
    }
  }
}
